"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationAbTestDeliveryType = void 0;
var NotificationAbTestDeliveryType;
(function (NotificationAbTestDeliveryType) {
    NotificationAbTestDeliveryType["SPLIT"] = "split";
    NotificationAbTestDeliveryType["SAMPLE"] = "sample";
})(NotificationAbTestDeliveryType = exports.NotificationAbTestDeliveryType || (exports.NotificationAbTestDeliveryType = {}));
//# sourceMappingURL=notification-ab-test-delivery-type.js.map